var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.537 0C29.045 0 37 8.38257 37 17.973C37 29.0956 27.676 36 18.5 36C15.466 36 12.099 35.2068 9.398 33.6565C8.4545 33.0976 7.659 32.683 6.6415 33.0075L2.9045 34.0891C1.961 34.3776 1.11 33.6565 1.3875 32.683L2.627 28.645C2.8305 28.0861 2.7935 27.4912 2.4975 27.0225C0.9065 24.1743 0 21.0556 0 18.027C0 8.54482 7.7885 0 18.537 0ZM26.9915 15.7376C25.678 15.7376 24.6235 16.7651 24.6235 18.0451C24.6235 19.307 25.678 20.3525 26.9915 20.3525C28.305 20.3525 29.3595 19.307 29.3595 18.0451C29.3595 16.7651 28.305 15.7376 26.9915 15.7376ZM18.463 15.7376C17.168 15.7196 16.095 16.7651 16.095 18.027C16.095 19.307 17.1495 20.3345 18.463 20.3525C19.7765 20.3525 20.831 19.307 20.831 18.0451C20.831 16.7651 19.7765 15.7376 18.463 15.7376ZM9.9345 15.7376C8.621 15.7376 7.5665 16.7651 7.5665 18.0451C7.5665 19.307 8.6395 20.3525 9.9345 20.3525C11.248 20.3345 12.3025 19.307 12.3025 18.0451C12.3025 16.7651 11.248 15.7376 9.9345 15.7376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2081340e2666e574e532bbd17a5526f8.svg";
export { ForwardRef as ReactComponent };